import React, {useEffect, useState} from 'react';
import ModalProgress from "../../common/ModalProgress";
import {CommonUtil} from "../../../utils/CommonUtil";
import Modal from "react-responsive-modal";
import {PermissionUtil} from "../../../utils/PermissionUtil";
import ReactSelect from "../../common/ReactSelect";
import Axios from "axios";
import {API} from "../../../api/APIClient";
import {Toast} from "../../../utils/ToastUtil";
import {NotificationManager} from "react-notifications";

export const ConversationEditor = (props) => {

    const {conversation} = props;
    const {callback} = props;

    const [isLoadingOrganisations, setIsLoadingOrganisations] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const [formData, setFormData] = useState({});
    const [organisationOptions, setOrganisationOptions] = useState([]);

    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState([]);

    useEffect(() => {
        if (conversation) {
            setFormData(conversation);
        }

        if (PermissionUtil.allOrgs(PermissionUtil.PermissionCategories.conversationTypes)) {
            fetchOrganisationsOverNetwork();
        }
    }, []);

    function handleCallback(action, data) {
        if (callback) {
            callback(action, data);
        }
    }

    function handleSubmit(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (validateForm()) {
            submitConversationOverNetwork();
        }
    }

    function validateForm() {
        let out = true;
        const errors = {};

        const requiredFields = [
            { "key" : "name", "label" : "Title" },
        ];

        for (let i = 0; i < requiredFields.length; i++) {
            let problem = false;

            const field = requiredFields[i];
            if (formData.hasOwnProperty(field.key)) {
                if (formData[field.key] === undefined || formData[field.key] === null) {
                    problem = true;
                }
            } else {
                problem = true;
            }

            if (problem) {
                out = false;
                errors[field.key] = "Please provide value for '" + field.label + "'";
            }
        }

        //setErrors(errors);

        return out;
    }

    function putFormData(data) {
        if (!CommonUtil.isObject(data)) {
            return;
        }

        const newFormData = CommonUtil.cloneObject(formData);
        const keys = Object.keys(data);

        keys.forEach((key) => {
            const newData = data[key];
            if (newData !== undefined) {
                newFormData[key] = data[key];
            } else {
                delete newFormData[key];
            }
        });

        setFormData(newFormData);
    }

    function handleBlur(event) {
        const name = event.target.name;
        const newTouched = CommonUtil.cloneObject(touched);
        newTouched[name] = true;
        setTouched(touched);
    }

    function handleChange(event) {
        const value = event.target.type === "checkbox" ? (event.target.checked ? 1 : 0) : event.target.value;

        let outData = {};
        outData[event.target.name] = value;
        putFormData(outData);
    }

    function pluginModalDidDismiss() {
        setModalOpen(false);
        setModalContent([]);
    }

    function fetchOrganisationsOverNetwork() {
        if (isLoadingOrganisations) return;
        setIsLoadingOrganisations(true);

        Axios.get(API.organisation.getOrganisations, {
            props : {
                appUsersOnly : 1
            }
        })
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    const organisations = resp.data.organisations;
                    if (organisations) {
                        const orgOptions = organisations.map((org) => {
                            return {
                                value : org.id.toString(),
                                label : org.name
                            }
                        });

                        orgOptions.unshift({
                            value : null,
                            label : "None (Global)"
                        });
                        setOrganisationOptions(orgOptions);
                    }
                } else {
                    console.log(API.formatError(resp));
                }
                setIsLoadingOrganisations(false);
            })
            .catch((e) => {
                console.log(e);
                setIsLoadingOrganisations(false);
            });
    }

    function submitConversationOverNetwork() {
        if (isUploading) return;
        setIsUploading(true);

        setErrorMessage(null);

        const data = {
            organisationID : CommonUtil.getOrDefault(formData, "organisationID", null),
            name : CommonUtil.getOrDefault(formData, "name", ""),
        };

        let endpoint = API.conversation.createConversationType;
        let successMessage = "Successfully created Conversation";
        if (conversation) {
            data.id = conversation.id;
            successMessage = "Successfully updated Conversation";
            endpoint = API.conversation.updateConversationType;
        }

        Axios.post(endpoint, data)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    NotificationManager.success(successMessage);

                    handleCallback("submit");
                } else {
                    setErrorMessage(API.formatError(resp));
                    setIsUploading(false);
                }
            })
            .catch((e) => {
                console.log(e);
                setIsUploading(false);
            });
    }

    // RENDER

    let modalTitle = "Create Conversation";
    if (conversation) {
        modalTitle = "Edit Conversation";
    }

    let organisationPicker = [];
    if (PermissionUtil.allOrgs(PermissionUtil.PermissionCategories.conversationTypes)) {
        if (conversation && conversation.id) {
            organisationPicker = (
                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="organisationID" className="text-right middle">Organisation</label>
                    </div>
                    <div className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "organisationID", null) && "error")}>
                        <input type={"text"} value={conversation.organisationName} readOnly={true} />
                    </div>
                </div>
            )
        } else {
            organisationPicker = (
                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="organisationID" className="text-right middle">Organisation</label>
                    </div>
                    <div
                        className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "organisationID", null) && "error")}>
                        <ReactSelect
                            name="organisationID"
                            className="react-select"
                            onChange={handleChange}
                            value={CommonUtil.getOrDefault(formData, "organisationID", null)}
                            options={organisationOptions}
                            onBlur={handleBlur}
                        />
                        <small className="error">{CommonUtil.getOrDefault(errors, "organisationID", "")}</small>
                    </div>
                </div>
            )
        }
    }

    let errorMessageElem = [];
    if (errorMessage) {
        errorMessageElem = (
            <div className={"alert alert-danger"}>
                {errorMessage}
            </div>
        );
    }

    return (
        <>
            <ModalProgress show={isUploading}/>
            <div className={"modal-head"}>
                <div className={"modal-head"}>
                    <h3>{modalTitle}</h3>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                <div className={"modal-body"}>

                    {organisationPicker}

                    <ConversationEditorTextInput
                        label={"* Title"}
                        name={"name"}
                        error={CommonUtil.getOrDefault(errors, "name", "")}
                        value={CommonUtil.getOrDefault(formData, "name", "")}
                        onChange={handleChange}
                        onBlur={handleBlur}/>

                    <ConversationEditorTextInput
                        label={"Key"}
                        name={"key"}
                        readonly={true}
                        placeholder={"(Automatically Generated)"}
                        value={CommonUtil.getOrDefault(formData, "key", "")} />

                    {errorMessageElem}

                </div>

                <div className="modal-footer">
                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <div className="btn-wrap">
                                {
                                    <React.Fragment>
                                        <button
                                            className="button secondary"
                                            type="button"
                                            onClick={() => handleCallback("submit")}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="button success"
                                            type="submit"
                                            disabled={!validateForm()}
                                        >
                                            Submit
                                        </button>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <Modal
                classNames={{modal: "modal-medium"}}
                open={modalOpen}
                modalId="PluginModal"
                onClose={pluginModalDidDismiss}
                center
            >
                {modalContent}
            </Modal>
        </>
    )

}

const ConversationEditorTextInput = (props) => {

    const {label} = props;
    const {name} = props;
    const {type} = props;
    const {value} = props;
    const {error} = props;
    const {onChange} = props;
    const {onBlur} = props;
    const {readonly} = props;
    const {placeholder} = props;

    let inputElem = (
        <input
            type={type ? type : "text"}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            readOnly={readonly}
            placeholder={placeholder}
        />
    )

    if (type === "textarea") {
        inputElem = (
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                readOnly={readonly}
                placeholder={placeholder}
            />
        );
    }

    return (
        <div className="grid-x grid-padding-x">
            <div className="small-3 cell">
                <label htmlFor="name" className="text-right middle ">{label}</label>
            </div>
            <div className={"small-9 cell " + (error && "error")}>
                {inputElem}

                <small className="error">{error}</small>
            </div>
        </div>
    )

}